import React from "react";
import { useState } from "react";

const Nav = () =>{
    const [isMenuOpen, setIsMenuOpen] = useState(false)

    const toggleMenu = () => {
      setIsMenuOpen(!isMenuOpen)
    }

    return(
        <nav className="navegator">
            <h1><a href="/">Jasio-dev</a></h1>
            <button className="menu-toggle" onClick={toggleMenu}>
            ☰
            </button>
            <ul className={isMenuOpen ? "open" : ""}>
                <li><a href="">Home</a></li>
                <li><a href="#about">About</a></li>
                <li><a href="#resume">Resume</a></li>
                <li><a href="#porfolio">Porfolio</a></li>
                <li><a href="#contact">Contact</a></li>
            </ul>
        </nav>
    );
}

export default Nav;